<!--发送短信-->
<template>
    <div>
        <div  class="short-popup" v-if="oneShow">
            <div class="short-box-hug">
                <div class="popup-text-top">
                    <span>发送确认</span>
                    <span style="float: right;margin-right: 30px;cursor: pointer;" @click="noneBtn()">X</span>
                </div>
                <!--提交号码-->
                <div class="short-hug clear-float" style="margin-top: 20px;">
                    <div class="short-left">提交号码：</div>
                    <div class="short-right clear-float">
                        <div class="send-phone">
                        <span :style="{'color':changeColor}">{{sendMessage.number}}</span>
                            <!-- <span :style="{'color':changeColor}">条</span> -->
                        </div>
                    </div>
                </div>
                <!--短信内容-->
                <div class="short-hug clear-float" style="margin-top: 10px;">
                    <div class="short-left">短信内容：</div>
                    <div class="short-right clear-float">
                        <div class="send-content"
                        style="word-wrap:break-word"
                        >{{sendMessage.content}}</div>
                    </div>
                </div>
                <!--短信字数-->
                <div class="short-hug clear-float" style="margin-top: 10px;">
                    <div class="short-left">短信字数：</div>
                    <div class="short-right clear-float">
                        <div class="send-big-small">
                            <span class="span1" :style="{'color': changeColor}">{{sendMessage.content.length}}</span>
                            <span class="span2">字</span>
                        </div>
                    </div>
                </div>
                <!--短信条数-->
                <div class="short-hug clear-float" style="margin-top: 10px;">
                    <div class="short-left">短信条数：</div>
                    <div class="short-right clear-float">

                        <div class="send-big-small">
                            <span class="span1" :style="{'color': changeColor}">{{sendMessage.shortNumber}}</span>
                            <span class="span2">条</span>

                            <div class="span3">
                                <span class="font_family icon-wenhaoyuanyiwenmianxing"
                                    style="font-size: 14px;margin-left: 10px;margin-right: 7px;"></span>
                                <span>计费规则</span>
                                <div class="ask-icon-select">
                                    <div>1.70个字计1条短信，超过70字按照67字每条计费。</div>
                                    <div>2.一个汉字，字母或标点空格都算作一个字。</div>
                                    <div>3.带标签短信以实际发送为准，有可能超过默认字数。</div>
                                    <div>4."签名"与"拒收请回复R"包含在字数中。</div>
                                    <div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>
                                    <div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--预计消耗-->
                <div class="short-hug clear-float" style="margin-top: 10px;">
                    <div class="short-left">预计消耗：</div>
                    <div class="short-right clear-float">
                        <div class="send-big-small">
                            <span class="span1" :style="{'color':changeColor}">{{sendMessage.number}}</span>
                            <span class="span2">人 X </span>
                            <span class="span1" :style="{'color':changeColor}">{{sendMessage.shortNumber}}</span>
                            <span class="span2">条/人 = </span>
                            <span class="span1" :style="{'color':changeColor}">{{sendMessage.number*sendMessage.shortNumber}}</span>
                            <span class="span2">条短信</span>
                        </div>
                    </div>
                </div>
                <!--软件检测-->
                <div class="short-hug clear-float" style="margin-top: 20px;" v-show="sendMessage.labelLen!=0 || sendMessage.shortUrlId!=''|| sendMessage.remindInfo!==''">
                    <div class="send-hug">
                        <div class="send-hug-top">软件检测：</div>
                        <div class="send-hug-small"  v-show="sendMessage.labelLen!=0">
                            <span class="circle"></span>
                            <span style="margin-left: 12px;">短信内容含变量" <span
                                    style="color: #FA5618;margin-left: 10px;margin-right: 10px;">{{sendMessage.labelText}}</span>  "，以实际发送条数为准！  </span>
                        </div>
                        <div class="send-hug-small" v-show="sendMessage.shortUrlId!=''">
                            <span class="circle"></span>
                            <span style="margin-left: 12px;">您输入的短信内容中 <span
                                    style="color: #FA5618;margin-left: 10px;margin-right: 10px;">含有网址链接，请确认网址前后加空格</span>，否则可能导致手机端网址链接打不开！ </span>
                        </div>
                        <div class="send-hug-small" v-show="sendMessage.remindInfo!='' && sendMessage.remindInfo">
                            <span class="circle"></span>
                            <span style="margin-left: 12px;"><span style="color: #FA5618;">{{sendMessage.remindInfo}}</span></span>
                        </div>
                    </div>
                </div>
                <!--按钮-->
                <div class="send-btn-hug">
                    <div class="send-btn-one" :style="{'background': changeColor}" @click="sureBtn">确定</div>
                    <div class="send-btn-two" :style="{'color':changeColor,'border-color': changeColor}" @click="noneBtn">
                        取消
                    </div>
                </div>
            </div>
        </div>
        <div class="short-popup"  v-if="!oneShow && sendMessage.success">
            <div class="short-box-hug-two">
                <div class="popup-text-top" style="background-color: #fff;">
                    <span style="float: right;margin-right: 30px;cursor: pointer;" @click="noneBtn()">X</span>
                </div>
                <div style="text-align: center;margin-top: 20px;" :style="{'color':changeColor}">
                    <span class="font_family icon-gouxuan" style="font-size: 56px;"></span>
                </div>
                <div class="send-success" :style="{'color':changeColor}">提交成功!</div>
                <div class="send-message">{{Timer}}s后自动跳转到短信记录及效果页面</div>
                <div class="send-btn-hug" style="width: 250px;">
                    <div class="send-btn-one" :style="{'background': changeColor}" @click="noneBtn">再次营销</div>
                    <!-- <router-link :to="{name: 'page-member-marketing', query:{to: 'date'}}" @click.native="refresh"> -->
                    <div v-if="showLookRecord" class="send-btn-two" :style="{'color':changeColor,'border-color': changeColor}" @click="RecordBtn">
                        查看记录
                    </div>
                    <!-- </router-link> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState ,mapMutations   } from "vuex"
  export default {
    props: [
      'sendMessage',
      'showRecordBtn', // 提交成功页是否显示查看记录按钮，false为不显示

    ],
    data() {
      return {
        //changeColor: '#2062E7',
        showLookRecord: true,
        oneShow: true,
        Timer: 10,
        newTime:null
      };
    },
    watch:{
        sendMessage:{//监听是否发送成功,接口返回才会显示倒数页面。勿动
        handler(newVal,oldVal){
            console.log('newVal',newVal, 'oldVal', oldVal);
            if(newVal.success){
                this.oneShow = false;
                // this.showLookRecord = false
                if(this.showRecordBtn == 'false'){
                    this.showLookRecord = false
                }
                this.Timer = 10;
                this.newTime = setInterval(() => {
                if (this.Timer > 1) {
                    this.Timer--
                } else {
                    clearInterval(this.newTime);
                    this.RecordBtn();
                }
                }, 1000)
            }
        },
        immediate:true,
        deep:true
        }
    },
    computed:{
    ...mapState({
          changeColor:"globalBG",      
        //   把city映射给currentCIty
      }),
      InTime(){//在早上9点到晚上22点间
        if(9<(new Date()).getHours() && (new Date()).getHours()<22){
            return false;
        }else{
            return true;
        }
      }
    },
    mounted() {
    //   console.log(this.sendMessage.content);
    //   console.log(this.sendMessage);
      this.timer="订单发送"+this.getDay(0, "-")+" "+this.getTimeMinutes();
    },
    methods: {
      refresh(){
        this.$router.go(0)
      },
      noneBtn() {//关闭
        clearInterval(this.newTime);
        this.$emit('transferName', {type: 1});
        this.$router.go(0)
      },
      sureBtn(){//确认，发送短信
        this.oneShow = false
        this.$emit('transferName',2)
      },
      RecordBtn() {
        this.noneBtn();
        clearInterval(this.newTime); 
        this.$emit('transferName', {type: 2});
        //跳转短信记录及效果
        // this.$router.push({ path: "/marketing", query: { to: '/marketing/sms/record'} });//跳转到短信记录页面
        let routeUrl = this.$router.resolve({
                path: "/marketing",
                query: {to:'/marketing/sms/record'}
              });
              window.open(routeUrl.href, '_blank');
      }
    }
  };
</script>
<!--发送短信-->
<style lang="scss" scoped>

    @mixin translate($number,$number2) {
        -webkit-transform: translateX($number) translateY($number2);
        -moz-transform: translateX($number) translateY($number2);
        -ms-transform: translateX($number) translateY($number2);
        -o-transform: translateX($number) translateY($number2);
        transform: translateX($number) translateY($number2);
    }

    .short-popup {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 101;
        overflow-y: auto;
    }

    .short-box-hug {
        position: absolute;
        width: 840px;
        max-height: 830px;
        // min-height:450px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
        opacity: 1;
        border-radius: 4px;
        top: 50%;
        left: 50%;
        @include translate(-50%, -50%);
    }

    .short-box-hug-two {
        width: 336px;
        height: 300px;
        background-color: #fff;
        position: absolute;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
        opacity: 1;
        border-radius: 4px;
        top: 50%;
        left: 50%;
        @include translate(-50%, -50%);

        .send-success {
            font-size: 18px;
            font-family: "Microsoft YaHei";
            font-weight: 600;
            line-height: 25px;
            color: rgba(32, 98, 231, 1);
            text-align: center;
            margin-top: 35px;
        }

        .send-message {
            font-size: 14px;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 20px;
            color: rgba(153, 153, 153, 1);
            text-align: center;
        }

        .send-popup-hug {

        }
    }

    .popup-text-top {
        height: 52px;
        overflow: hidden;
        background: rgba(244, 245, 249, 1);

        span {
            font-size: 20px;
            font-family: "Microsoft YaHei";
            font-weight: 600;
            line-height: 52px;
            color: rgba(51, 51, 51, 1);
            margin-left: 30px;
        }

    }

    .short-hug {
        /*overflow: hidden;*/
        .new-button {
            width: 111px;
            height: 30px;
            background: rgba(255, 255, 255, 1);
            border-radius: 3px;
            font-size: 14px;
            font-weight: 400;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
        }

        .short-left {
            width: 105px;
            float: left;
            font-size: 14px;
            font-weight: 400;
            line-height: 30px;
            color: rgba(102, 102, 102, 1);
            text-align: right;
        }

        .short-right {
            width: 680px;
            float: left;
            margin-left: 10px;
        }

        .send-phone {
            font-size: 22px;
            font-weight: 400;
            line-height: 30px;
        }

        .send-content {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            color: rgba(102, 102, 102, 1);
        }

        .send-big-small {
            .span1 {
                font-size: 18px;
                font-weight: 400;
                line-height: 30px;
            }

            .span2 {
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                color: rgba(102, 102, 102, 1);
            }

            .span3 {
                width: 100px;
                height: 26px;
                background: rgba(255, 118, 0, 0.1);
                display: inline-block;
                margin-left: 50px;
                font-size: 14px;
                font-weight: 400;
                line-height: 26px;
                color: rgba(255, 118, 0, 1);
                cursor: pointer;
                position: relative;

                .ask-icon-select {
                    position: absolute;
                    bottom: 50px;
                    margin-left: -158px;
                    display: none;
                    width: 375px;
                    line-height: 20px;
                    padding: 20px;
                    background-color: #fff;
                    text-align: left;
                    box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
                    color: #999999;
                    font-size: 14px;
                }

                .ask-icon-select:before {
                    position: absolute;
                    content: "";
                    width: 0;
                    height: 0;
                    right: 50%;
                    margin-left: -4px;
                    top: 100%;
                    border-left: 8px solid transparent;
                    border-top: 8px solid #fff;
                    border-right: 8px solid transparent;
                }
            }

            .span3:hover {
                .ask-icon-select {
                    display: block;
                }
            }
        }

        .send-hug {
            width: 765px;
            height: 220px;
            background: rgba(247, 247, 250, 1);
            margin: 0 auto;
            overflow: hidden;

            .send-hug-top {
                font-size: 14px;
                font-family: "Microsoft YaHei";
                font-weight: 600;
                line-height: 20px;
                color: rgba(102, 102, 102, 1);
                margin-top: 25px;
                margin-left: 30px;
                margin-bottom: 30px;
            }

            .send-hug-small {
                font-size: 14px;
                font-family: "Microsoft YaHei";
                font-weight: 400;
                line-height: 20px;
                color: rgba(153, 153, 153, 1);
                margin-left: 40px;
                margin-bottom: 15px;

                .circle {
                    width: 4px;
                    height: 4px;
                    background: rgba(32, 98, 231, 1);
                    border-radius: 50%;
                    display: inline-block;
                    float: left;
                    margin-top: 8px;
                }
            }

        }


    }

    .send-btn-hug {
        width: 270px;
        margin: 30px auto 40px;
        overflow:hidden;
        display: flex;
        justify-content: center;
        .send-btn-one {
            width: 110px;
            height: 32px;
            margin: 0 8px;
            background: rgba(32, 98, 231, 1);
            opacity: 1;
            font-size: 14px;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 32px;
            color: rgba(255, 255, 255, 1);
            border-radius: 3px;
            text-align: center;
            cursor: pointer;
            float: left;
        }

        .send-btn-two {
            width: 108px;
            height: 32px;
             margin: 0 8px;
            /*background:rgba(32,98,231,1);*/
            opacity: 1;
            font-size: 14px;
            font-family: "Microsoft YaHei";
            border: 1px solid rgba(39, 112, 251, 1);
            font-weight: 400;
            line-height: 32px;
            border-radius: 3px;
            text-align: center;
            cursor: pointer;
            float: right;
        }
    }


</style>
<style>
    .el-textarea__inner {
        border: 1px solid #dcdfe6 !important;
    }
</style>
